import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  FormText,
  Button,
} from "reactstrap";

import {connect} from 'react-redux'
import {signIn} from '../../store/actions/authActions'

class SignIn extends Component {
  state = {};

  handleChange = (e) => {
    this.setState({
        [e.target.id] : e.target.value
    })
  };

  handleSubmit = (e) => {
      e.preventDefault();
      this.props.signIn(this.state)
  };

  render() {
    const {authError} = this.props;
    console.log('ssss>>>'+authError)
    return (
      <div>
              <Card>
                <CardBody>
                  <CardTitle>
                    <h4 className="text-center">User Login</h4>
                  </CardTitle>
                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                      <Input
                        required
                        type="email"
                        name="email"
                        id="email"
                        placeholder="user@boooya.lk"
                        onChange={this.handleChange}
                      />
                         <FormText>
                        Your Email Address
                      </FormText>

                    </FormGroup>

                    <FormGroup>
                      <Input
                        required
                        type="password"
                        name="password"
                        id="password"
                        placeholder="password"
                        onChange={this.handleChange}
                      />
                      <FormText>
                        Your Password
                      </FormText>
                    </FormGroup>


                    {authError ? (
                      <p className="text-danger">Invalid Login!</p>
                    ): null}

                    <FormGroup>
                        <Button color="primary" block >Login</Button>
                    </FormGroup>

                  </Form>
                </CardBody>
              </Card>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    signIn: (creds) => dispatch(signIn(creds))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(SignIn);
